import { renderDateViewCalendar } from '@mui/x-date-pickers/dateViewRenderers';
import { usePickerContext } from '@mui/x-date-pickers/hooks';

/** @param {Parameters<typeof renderDateViewCalendar>[0]} props */
function MobileDateTimePickerDateView(props) {
  const { setView, views } = usePickerContext();
  const dateViews = views.filter(view => ['day', 'month', 'year'].includes(view));
  const firstTimeView = views.find(view => ['hours', 'meridiem', 'minutes', 'seconds'].includes(view));
  const handleChange = (value, selectionState, selectedView) => {
    props.onChange(value, selectionState, selectedView);
    // v8 separates date and time into steps; retain v7's automatic advance.
    if (selectionState === 'finish' && (selectedView || props.view) === dateViews.at(-1) && firstTimeView) {
      setView(firstTimeView);
    }
  };
  return renderDateViewCalendar({ ...props, onChange: handleChange });
}

/** @type {typeof renderDateViewCalendar} */
export default function renderMobileDateTimePickerDateView(props) {
  return <MobileDateTimePickerDateView {...props} />;
}
